module.exports = __webpack_public_path__ + "static/media/riskyActivityQuestion.84e0e324.mp3";